export default __webpack_public_path__ + "images/60ac4a6e40e70a887cb42c5d5ce42491-3_mobile_659x494.webp";